"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var mixins_1 = require("../theme/mixins");

var radioDisplay = 'inline-block';

exports.styles = function (theme) {
  return {
    label: {
      display: 'flex',
      position: 'relative',
      cursor: 'pointer',
      fallbacks: [{
        display: '-ms-flexbox'
      }, {
        display: '-webkit-box'
      }, {
        display: '-webkit-flex'
      }]
    },
    radio: {
      width: theme.x4,
      height: theme.x4,
      minWidth: theme.x4,
      position: 'relative',
      display: radioDisplay,
      top: 2,
      marginRight: theme.x2,
      marginLeft: theme.x05,
      '&$focus $border': {
        borderColor: theme.colorBorder.focus
      }
    },
    background: {
      width: theme.x1,
      height: theme.x1,
      border: '6px solid transparent',
      borderRadius: '100%',
      position: 'absolute'
    },
    border: __assign(__assign({}, mixins_1.border(theme)), {
      borderRadius: '100%',
      width: 14,
      height: 14,
      position: 'absolute'
    }),
    input: {
      opacity: 0,
      display: radioDisplay,
      position: 'absolute',
      width: theme.x4,
      height: theme.x4,
      marginRight: theme.x2,
      marginLeft: theme.x05,
      marginBottom: 0,
      marginTop: 0,
      '&:checked + $background + $border': {
        borderColor: theme.colorPrimary.normal,
        background: 'inherit'
      },
      '&:checked + $background': {
        borderColor: theme.colorPrimary.normal
      }
    },
    text: {
      display: radioDisplay
    },
    disabled: {
      opacity: theme.toneValueBase,
      cursor: 'default',
      '& $radio $border': {
        borderColor: theme.colorTextSecondary.normal
      },
      '& $radio $background': {
        backgroundColor: theme.colorIconSecondary.normal
      }
    },
    focus: {}
  };
};